module.exports = __webpack_public_path__ + "ScreenShotRegExPrayersResult.06ba11db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/graphics/ScreenShotRegExPrayersResult.png
// module id = IYtc
// module chunks = 0